import EiduPruebaInscripcion from "containers/Matricula/EiduPrueba";

export default function EiduPruebaPage() {
  return <EiduPruebaInscripcion />;
}
